// Marketing chrome shell — the sticky nav + routed page outlet + footer.
// Every public route renders inside this layout (React Router 7 nested
// route; see src/router.tsx). A skip link keeps keyboard users able to
// jump past the nav (WCAG 2.2 — 2.4.1 Bypass Blocks).

import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";

import { CookieConsent } from "@/components/CookieConsent";
import { MarketingFooter } from "@/components/MarketingFooter";
import { MarketingNav } from "@/components/MarketingNav";

export function MarketingLayout({ children }: { readonly children?: React.ReactNode }): React.ReactElement {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-screen flex-col bg-[var(--bg-surface)]">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-[8px] focus:bg-[var(--bg-raised)] focus:px-4 focus:py-2 focus:font-sans focus:text-sm focus:font-medium focus:text-[var(--fg-primary)] focus:shadow-[var(--shadow-md)]"
      >
        {t("nav.skip_to_content")}
      </a>
      <MarketingNav />
      <main id="main" className="flex-1">{children ?? <Outlet />}</main>
      <MarketingFooter />
      <CookieConsent />
    </div>
  );
}
